import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";

import { withRouter } from "react-router-dom";
import { compose } from "redux";
import UserMgmtList from "./UserMgmtList";

import injectReducer from "helpers/injectReducer";
import injectSaga from "helpers/injectSaga";
import userMgmtReducer from "store/UserMgmt/reducer";
import userMgmtSaga from "store/UserMgmt/saga";

const userMgmtKey = "UserMgmt";

const withUserMgmtReducer = injectReducer({
  key: userMgmtKey,
  reducer: userMgmtReducer,
});
const withUserMgmtSaga = injectSaga({ key: userMgmtKey, saga: userMgmtSaga });

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Container fluid className="pt-4">
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <div className="d-flex">
                    <h4 className="mt-0 page-title">User Management</h4>
                  </div>

                  <UserMgmtList />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default compose(
  withUserMgmtReducer,
  withUserMgmtSaga,
  withRouter
)(Index);
//export default withRouter(withConnect)(Index);
